import { cn } from '@/lib/utils';

interface VideoDisplayTitleProps {
  title?: string;
  className?: string;
}

export default function VideoDisplayTitle({ title, className }: VideoDisplayTitleProps) {
  return (
    <span className={cn('pointer-events-none absolute z-10 truncate text-white', className)}>
      {title}
    </span>
  );
}
